module.exports = __webpack_public_path__ + "static/media/model-mission-14.0e167976.png";